import { base64ToBlob } from './base64Blob';
import type { ApiResult } from '../services/types';

/** DMS file download (base64 in JSON) — shared by case-management and file-management APIs. */
export type DmsFileDownloadResponse = {
  file_name?: string;
  file_size?: number;
  file_content?: string;
  content_type?: string;
  location?: string;
  last_modified?: string;
  success?: boolean;
  message?: string;
};

export function blobFromDmsDownloadResponse(payload: DmsFileDownloadResponse): ApiResult<Blob> {
  if (payload.success === false) {
    return { success: false, message: payload.message?.trim() || 'Download failed.' };
  }
  const content = payload.file_content?.trim();
  if (!content) {
    return { success: false, message: payload.message?.trim() || 'File content is empty.' };
  }
  try {
    const blob = base64ToBlob(content, payload.content_type ?? 'application/octet-stream');
    if (!blob.size) {
      return { success: false, message: 'File is empty or unavailable.' };
    }
    return { success: true, data: blob };
  } catch {
    return { success: false, message: 'Could not decode file content.' };
  }
}
